import React, { useState, useEffect } from "react";
// import axios from "axios"; // ak budeš chcieť použiť axios na fetch
import { saveAs } from "file-saver";

// Pomocné funkcie na prácu s backendom
async function ulozitMechanizmy(data) {
  const resp = await fetch('http://localhost:3040/api/mechanizmy/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return await resp.json();
}

async function nacitatMechanizmy() {
  const resp = await fetch('http://localhost:3040/api/mechanizmy/load');
  return await resp.json();
}
// fallback pre neznáme obdobie
// TODO: Nastavte správne defaultné ceny podľa aktuálnych štatistík alebo firemných pravidiel
const defaultCenyPHM = { nafta: 1.65, benzin: 1.75 };

// Typy mechanizmov a spotreby podľa zadania
const mechanizmy = [
  { typ: "elektrocentrála", spotreba: 3.2 },
  { typ: "rezačka asfaltu", spotreba: 3.5 },
  { typ: "vibračná doska", spotreba: 1.8 },
  { typ: "krovinorez", spotreba: 0.8 },
  { typ: "rezatova pila", spotreba: 0.8 }
];



// Ceny PHM podľa mesiacov (príklad pre rok 2025, podľa štatistického úradu)
// Formát: cenyPHMTabulka[rok][mesiac][palivo]
const cenyPHMTabulka = {
  2025: {
    1: { benzin: 1.584, nafta: 1.537 },
    2: { benzin: 1.583, nafta: 1.548 },
    3: { benzin: 1.519, nafta: 1.491 },
    4: { benzin: 1.507, nafta: 1.444 },
    5: { benzin: 1.492, nafta: 1.394 },
    6: { benzin: 1.515, nafta: 1.417 },
    7: { benzin: 1.502, nafta: 1.467 },
    8: { benzin: 1.511, nafta: 1.435 },
    9: { benzin: 1.531, nafta: 1.456 },
    10: { benzin: 1.506, nafta: 1.449 },
    11: { benzin: 1.527, nafta: 1.496 },
    12: { benzin: 1.471, nafta: 1.424 }
  }
};

function EvidenciaMechanizmov() {
  // Vypočíta trvanie v hodinách medzi časom od (odCas) a do (doCas)
  function vypocitajTrvanie(odCas, doCas) {
    // odCas, doCas vo formáte "HH:MM"
    const [hodOd, minOd] = odCas.split(":").map(Number);
    const [hodDo, minDo] = doCas.split(":").map(Number);
    let trvanie = (hodDo + minDo / 60) - (hodOd + minOd / 60);
    if (trvanie < 0) trvanie += 24; // prechod cez polnoc
    return trvanie;
  }

      // Načítanie posledných údajov z localStorage
      function loadLastInputs() {
        try {
          const data = JSON.parse(localStorage.getItem('mechanizmyLastInputs'));
          return data || {};
        } catch { return {}; }
      }
      const last = loadLastInputs();
      const [typ, setTyp] = useState(last.typ || mechanizmy[0].typ);
      const [datum, setDatum] = useState(last.datum || "");
      const [odCas, setOdCas] = useState(last.odCas || ""); // čas od
      const [doCas, setDoCas] = useState(last.doCas || ""); // čas do
      const [phm, setPhm] = useState(last.phm || "nafta");
      const [zaznamy, setZaznamy] = useState([]);
      const [msg, setMsg] = useState("");
      const [mechanizmyData, setMechanizmy] = useState([]); // Stav pre načítané mechanizmy

      // Uložiť údaje na server
      async function handleUlozit() {
        setMsg("Ukladám...");
        const res = await ulozitMechanizmy(mechanizmy);
        setMsg(res.ok ? "Údaje uložené na server." : (res.error || "Chyba pri ukladaní."));
      }

      // Stiahnuť údaje zo servera ako súbor
      async function handleStiahnut() {
        setMsg("Načítavam...");
        const res = await nacitatMechanizmy();
        if (res.ok && res.data) {
          // Stiahnuť ako súbor
          const blob = new Blob([JSON.stringify(res.data, null, 2)], { type: 'application/json' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'mechanizmy-data.json';
          a.click();
          URL.revokeObjectURL(url);
          setMsg("Údaje stiahnuté.");
        } else {
          setMsg(res.error || "Chyba pri načítaní.");
        }
      }

      // Načítať údaje zo servera do tabuľky (bez sťahovania)
      async function handleNacitat() {
        setMsg("Načítavam...");
        const res = await nacitatMechanizmy();
        if (res.ok && res.data) {
          setMechanizmy(res.data);
          // Info o počte záznamov a poslednej úprave
          let info = `Načítaných záznamov: ${Array.isArray(res.data) ? res.data.length : 0}`;
          if (res.data && res.data.length && res.data[0].updatedAt) {
            info += `, posledná úprava: ${new Date(res.data[0].updatedAt).toLocaleString()}`;
          }
          setMsg(info);
        } else {
          setMsg(res.error || "Chyba pri načítaní.");
        }
      }

      function saveLastInputs(data) {
        localStorage.setItem('mechanizmyLastInputs', JSON.stringify(data));
      }

      // Funkcia na získanie ceny PHM podľa dátumu a typu
      function getCenaPHM(datum, phm) {
        if (!datum) return defaultCenyPHM[phm] || 0;
        const d = new Date(datum);
        const rok = d.getFullYear();
        const mesiac = d.getMonth() + 1;
        if (cenyPHMTabulka[rok] && cenyPHMTabulka[rok][mesiac] && cenyPHMTabulka[rok][mesiac][phm]) {
          return cenyPHMTabulka[rok][mesiac][phm];
        }
        return defaultCenyPHM[phm] || 0;
      }

      const spotreba = mechanizmy.find(m => m.typ === typ)?.spotreba || 0;
      const trvanie = odCas && doCas ? vypocitajTrvanie(odCas, doCas) : 0;
      const cenaPHM = getCenaPHM(datum, phm);
      const celkovaSpotreba = (trvanie * spotreba).toFixed(2);
      const cena = (celkovaSpotreba * cenaPHM).toFixed(2);

      function handleTypChange(e) {
        const vybrany = mechanizmy.find(m => m.typ === e.target.value);
        setTyp(vybrany.typ);
        saveLastInputs({ typ: vybrany.typ, datum, odCas, doCas, phm });
      }
      function handleDatumChange(e) {
        setDatum(e.target.value);
        saveLastInputs({ typ, datum: e.target.value, odCas, doCas, phm });
      }
      function handleOdChange(e) {
        setOdCas(e.target.value);
        saveLastInputs({ typ, datum, odCas: e.target.value, doCas, phm });
      }
      function handleDoChange(e) {
        setDoCas(e.target.value);
        saveLastInputs({ typ, datum, odCas, doCas: e.target.value, phm });
      }
      function handlePhmChange(e) {
        setPhm(e.target.value);
        saveLastInputs({ typ, datum, odCas, doCas, phm: e.target.value });
      }

      function handlePridatZaznam() {
        if (!datum || !odCas || !doCas) return;
        setZaznamy([
          ...zaznamy,
          {
            typ,
            datum,
            odCas,
            doCas,
            spotreba,
            trvanie: Number(trvanie.toFixed(2)),
            celkovaSpotreba: Number(celkovaSpotreba),
            phm,
            cena: Number(cena)
          }
        ]);
        saveLastInputs({ typ, datum, odCas, doCas, phm });
      }

      function exportJSON() {
        const blob = new Blob([JSON.stringify(zaznamy, null, 2)], { type: "application/json" });
        saveAs(blob, "mechanizmy.json");
      }

      function exportCSV() {
        if (zaznamy.length === 0) return;
        const header = Object.keys(zaznamy[0]).join(",");
        const rows = zaznamy.map(z => Object.values(z).join(","));
        const csv = [header, ...rows].join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        saveAs(blob, "mechanizmy.csv");
      }

      function exportXLS() {
        if (zaznamy.length === 0) return;
        let xls = '<table border="1"><tr>' + Object.keys(zaznamy[0]).map(h => `<th>${h}</th>`).join("") + '</tr>';
        zaznamy.forEach(z => {
          xls += '<tr>' + Object.values(z).map(v => `<td>${v}</td>`).join("") + '</tr>';
        });
        xls += '</table>';
        const blob = new Blob([xls], { type: "application/vnd.ms-excel" });
        saveAs(blob, "mechanizmy.xls");
      }

      function exportPDF() {
        // Jednoduchý export do PDF cez window.print (tabuľka)
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Mechanizmy</title></head><body>');
        printWindow.document.write('<h2>Záznamy mechanizmov</h2>');
        printWindow.document.write(document.getElementById('zaznamy-tabulka').outerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
      }

      return (
        <div style={{maxWidth: 600, margin: "2em auto", padding: 20, border: "1px solid #ccc", borderRadius: 8}}>
          <h2>Evidencia mechanizmov</h2>
          <div>
            <label>Typ mechanizmu:<br/>
              <select value={typ} onChange={handleTypChange}>
                {mechanizmy.map(m => (
                  <option key={m.typ} value={m.typ}>{m.typ}</option>
                ))}
              </select>
            </label>
          </div>
          <div>
            <label>Dátum:<br/>
              <input type="date" value={datum} onChange={handleDatumChange} />
            </label>
          </div>
          <div>
            <label>Čas od:<br/>
              <input type="time" value={odCas} onChange={handleOdChange} />
            </label>
          </div>
          <div>
            <label>Čas do:<br/>
              <input type="time" value={doCas} onChange={handleDoChange} />
            </label>
          </div>
          <div>
            <label>Spotreba (l/hod):<br/>
              <input type="number" value={spotreba} readOnly style={{background:'#eee'}} />
            </label>
          </div>
          <div>
            <label>PHM:<br/>
              <select value={phm} onChange={e => setPhm(e.target.value)}>
                {['benzin','nafta'].map(k => (
                  <option key={k} value={k}>{k}</option>
                ))}
              </select>
            </label>
          </div>
          <hr/>
          <div>Trvanie: <b>{trvanie.toFixed(2)}</b> hod</div>
          <div>Spotreba spolu: <b>{celkovaSpotreba}</b> l</div>
          <div>Cena PHM: <b>{cena}</b> €</div>
          <button onClick={handlePridatZaznam} style={{marginTop:10}}>Pridať záznam</button>

          <hr/>
          <h3>Záznamy</h3>
          <div style={{overflowX:'auto'}}>
            <table id="zaznamy-tabulka" border="1" cellPadding="4" style={{minWidth:600}}>
              <thead>
                <tr>
                  <th>Typ</th><th>Dátum</th><th>Od</th><th>Do</th><th>Spotreba (l/hod)</th><th>Trvanie (h)</th><th>Spotreba (l)</th><th>PHM</th><th>Cena PHM (€)</th><th>Cena (€)</th>
                </tr>
              </thead>
              <tbody>
                {zaznamy.map((z,i) => (
                  <tr key={i}>
                    <td>{z.typ}</td>
                    <td>{z.datum}</td>
                    <td>{z.odCas}</td>
                    <td>{z.doCas}</td>
                    <td>{z.spotreba}</td>
                    <td>{z.trvanie}</td>
                    <td>{z.celkovaSpotreba}</td>
                    <td>{z.phm}</td>
                    <td>{getCenaPHM(z.datum, z.phm)}</td>
                    <td>{z.cena}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{margin:'16px 0', display:'flex', gap:12}}>
            <button onClick={handleUlozit}>Uložiť údaje na server</button>
            <button onClick={handleStiahnut}>Stiahnuť údaje zo servera</button>
            <button onClick={handleNacitat}>Načítať údaje zo servera</button>
            {msg && <span style={{marginLeft:8, color:'#1976d2'}}>{msg}</span>}
          </div>
          <div style={{marginTop:10, display:'flex', gap:10}}>
            <button onClick={exportJSON}>Stiahnuť JSON</button>
            <button onClick={exportCSV}>Stiahnuť CSV</button>
            <button onClick={exportXLS}>Stiahnuť XLS</button>
            <button onClick={exportPDF}>Stiahnuť PDF</button>
          </div>
        </div>
      );
}

export default EvidenciaMechanizmov;

